export default __webpack_public_path__ + "static/O0107-fddc6c659723ce879d40969d3c236af7.png";